import React from "react";
import { Link } from "react-router-dom";
import "./banner.css";
import Navbar from "./Navbar";
class Banner extends React.Component {
  render() {
    return (
      <div className="banner">
        <Navbar />
        <div className="banner__content">
          <h2>Find Your Dream Venue</h2>
          <h5>
            Search for venues and pricing in the Kansas City area, instantly.
          </h5>
          <Link to="/result">
            <button>Get The App</button>
          </Link>
        </div>
      </div>
    );
  }
}
export default Banner;
